import { getRoomArea } from './getRoomArea';
import { getTotalArea } from './getTotalArea';
import { isFlat } from '../category/isFlat';
import { NBSP } from 'shared/constants/symbols';

import type { IOffer } from 'shared/offer';

export function getOfferArea(offer: IOffer): string | undefined {
  const roomArea = getRoomArea(offer);
  const totalArea = getTotalArea(offer);
  const isFlatCategory = isFlat(offer);

  if (isFlatCategory && roomArea) {
    return `${roomArea}${NBSP}м²`;
  }

  if (totalArea) {
    return `${totalArea}${NBSP}м²`;
  }

  return undefined;
}
